
export default {
  defaultObject () {
    return {
      id: null,
      name: '',
      unitId: null,
      document: null,
      validUntil: '',
      createdAt: '',
      updatedAt: ''
    }
  }
}